import { render, staticRenderFns } from "./ListaItens.vue?vue&type=template&id=161d9abe"
import script from "./ListaItens.vue?vue&type=script&lang=js"
export * from "./ListaItens.vue?vue&type=script&lang=js"
import style0 from "./ListaItens.vue?vue&type=style&index=0&id=161d9abe&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports